import { Button } from '@sea-snag/ui';
import { Loader2, Pencil, Plus, RotateCcw } from 'lucide-react';

import { openCatalog, resetToDefault } from '../../stores/dashboard-store';

// ── Dashboard Header ─────────────────────────────────────────────────

interface DashboardHeaderProps {
  isEditMode: boolean;
  isSaving: boolean;
  toggleEditMode: () => void;
}

export function DashboardHeader({ isEditMode, isSaving, toggleEditMode }: DashboardHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground text-sm">
          {isEditMode
            ? 'Drag widgets to reorder, add or remove widgets'
            : 'Your charter business at a glance'}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {isSaving && <Loader2 className="text-muted-foreground size-4 animate-spin" />}
        {isEditMode && (
          <>
            <Button variant="outline" size="sm" onClick={() => openCatalog()}>
              <Plus className="size-4" data-icon="inline-start" />
              Add Widget
            </Button>
            <Button variant="outline" size="sm" onClick={() => resetToDefault()}>
              <RotateCcw className="size-4" data-icon="inline-start" />
              Reset
            </Button>
          </>
        )}
        <Button variant={isEditMode ? 'default' : 'outline'} size="sm" onClick={toggleEditMode}>
          {isEditMode ? (
            'Done'
          ) : (
            <>
              <Pencil className="size-4" data-icon="inline-start" />
              Customize
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
